import {FC, useState, useEffect, useRef} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col, Form, Button, Dropdown, Image} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {COMTRADE_DATA_YEAR} from '../../../libs/constant'
import {ListCountryTable} from './components/ListCountryTable'
import {getAllCountry} from './core/_requests'

import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {ListCountryResultRow} from './core/_models'

const TradeDataManagementPage: FC<{subject: string}> = ({subject}) => {
  const intl = useIntl()
  const axiosPrivate = useAxiosPrivate()
  const btnSearchRef = useRef(null)
  const [isLoadingCountry, setIsLoadingCountry] = useState(false)
  const [isDisableBtnSearch, setIsDisableBtnSearch] = useState(true)
  const [showResultSection, setShowResultSection] = useState(false)

  const [year, setYear] = useState('')
  const [hsVersion, setHSVersion] = useState('')
  const [sourceType, setSourceType] = useState('')
  const [isSearchAllow, setIsSearchAllow] = useState(false)
  const [listCountryTableData, setListCountryTableData] =
    useState<Array<ListCountryResultRow> | null>()

  const [countData, setCountData] = useState(0)

  const handleApplyFilter = (filters: {year: string; hsVersion: string; sourceType: string}) => {
    setYear(filters.year)
    setHSVersion(filters.hsVersion)
    setSourceType(filters.sourceType)

    setListCountryTableData([])
    setShowResultSection(true)
    fetchListCountry()
  }

  const fetchListCountry = () => {
    setIsLoadingCountry(true)

    getAllCountry(axiosPrivate, {
      hs_vr: hsVersion,
      year,
      source_type: sourceType,
    })
      .then((res) => {
        const resData = res.data.data
        if (resData.count > 0) {
          setCountData(resData.count)
          setListCountryTableData(resData.table_data)
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        setIsLoadingCountry(false)
      })
  }

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {
            title: 'Home',
            path: '/',
            isSeparator: false,
            isActive: false,
          },
          {
            title: '',
            path: '',
            isSeparator: true,
            isActive: false,
          },
        ]}
      >
        {intl.formatMessage({id: subject})}
      </PageTitle>
      <>
        <Row className='mb-5'>
          <Col>
            <Card className='card-custom card-border'>
              <Card.Body className='d-flex justify-content-around align-items-center'>
                <Image src='/media/tina/img-result-market.jpg' thumbnail width={110} />
                <div className='ms-5 d-flex flex-column justify-content-center'>
                  <h3 className='text-primary'>Trade Flow Data</h3>
                  <div className='text-gray-700'>
                    This section provides complete export and import volumes for all countries,
                    enabling deep macroeconomic analysis. Access transparent information on primary
                    data sources, track historical data through documented versions, and leverage
                    reliable metrics to drive your research and strategic decisions. To view the
                    trade flow data, please apply the filters below.
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className='mb-5'>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title>
                  <span className='fa fa-magnifying-glass px-2'></span>
                  <h3 className='text-gray-700'>Search the trade flow country</h3>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <Row className='mb-5 d-flex align-items-end'>
                  <Col lg={10} md={10}>
                    <Row>
                      <Col lg={4} md={4}>
                        <Form.Group>
                          <Form.Label>Year</Form.Label>
                          <Form.Select value={year} onChange={(e) => setYear(e.target.value)}>
                            <option value='' disabled>
                              Select Year
                            </option>
                            <option value='2020'>2020</option>
                            <option value='2021'>2021</option>
                            <option value='2022'>2022</option>
                            <option value='2023'>2023</option>
                            <option value='2024'>2024</option>
                            <option value='2025'>2025</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg={4} md={4}>
                        <Form.Group>
                          <Form.Label>HS Version</Form.Label>
                          <Form.Select
                            value={hsVersion}
                            onChange={(e) => setHSVersion(e.target.value)}
                          >
                            <option value='' disabled>
                              Select HS Version
                            </option>
                            <option value='H4'>H4</option>
                            <option value='H5'>H5</option>
                            <option value='H6'>H6</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col lg={4} md={4}>
                        <Form.Group>
                          <Form.Label>Data Source Type</Form.Label>
                          <Form.Select
                            value={sourceType}
                            onChange={(e) => setSourceType(e.target.value)}
                          >
                            <option value='' disabled>
                              Select Data Source Type
                            </option>
                            <option value='comtrade'>Comtrade</option>
                            <option value='manual'>Manual</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                  <Col lg={2} md={2}>
                    {/* Conditional Import Button */}
                    <div className='text-end'>
                      <Button
                        variant='primary'
                        className='btn-md w-100'
                        onClick={() =>
                          handleApplyFilter({
                            year,
                            hsVersion,
                            sourceType,
                          })
                        }
                        disabled={!year && !hsVersion && !sourceType}
                      >
                        Apply
                      </Button>
                    </div>
                  </Col>
                </Row>
                {showResultSection ? (
                  <>
                    <ListCountryTable
                      rows={listCountryTableData}
                      year={year}
                      isLoading={isLoadingCountry}
                      sourceType={sourceType}
                    />
                  </>
                ) : (
                  ''
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </>
    </>
  )
}

export default TradeDataManagementPage
